import { Box, makeStyles, createStyles } from "@material-ui/core";
import React from "react";
import { getRegionDisplayName } from "../config/deploymentRegions";

const useStyles = makeStyles(() =>
  createStyles({
    badge: { textTransform: "capitalize" },
  })
);

export const EnvStatus: Record<string, { value: string }> = {
  global: { value: "Global" },
  "eu-west": { value: "EU West (Ireland)" },
  australia: { value: "Australia" },
  "asia-pacific": { value: "Asia Pacific" },
  prod: { value: "Production" },
  ap: { value: "South-east Asia (Singapore)" },
  au: { value: "Australia East" },
  uk: { value: "United Kingdom" },
  europe: { value: "Europe" },
  "us-west-2": { value: "US West (Oregon)" },
  "us-east-1": { value: "US East (N. Virginia)" },
  "us-east-2": { value: "US East (Ohio)" },
  "us-west-1": { value: "US West (N. California)" },
  "sa-east-1": { value: "São Paulo" },
  "eu-north-1": { value: "EU North (Stockholm)" },
  "me-south-1": { value: "Middle East (Bahrain)" },
  "af-south-1": { value: "Africa (Cape Town)" },
  "ap-southeast-1": { value: "Asia Pacific (Singapore)" },
  "ap-northeast-1": { value: "Asia Pacific (Tokyo)" },
  "ap-southeast-2": { value: "Asia Pacific (Sydney)" },
  "ap-southeast-4": { value: "Australia (Melbourne)" },
  other: { value: "Other" },
};

export type EnvKeyType = string;

interface EnvBadgeProps {
  env: EnvKeyType;
}

export const getResolvedEnv = (env: EnvKeyType): string => {
  return EnvStatus[env]?.value ?? getRegionDisplayName(env) ?? env;
};

export const EnvBadge: React.FC<EnvBadgeProps> = ({ env }) => {
  const classes = useStyles();
  const display = getResolvedEnv(env);
  return <Box className={classes.badge}>{display}</Box>;
};
